module.exports = __webpack_public_path__ + "img/borderEtPolygonWhite.2c4edcb3.svg";